import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=9f90af92"
import script from "./TablePagination.vue?vue&type=script&lang=js"
export * from "./TablePagination.vue?vue&type=script&lang=js"
import style0 from "./TablePagination.vue?vue&type=style&index=0&id=9f90af92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports